import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './components/common/stars.css'
import Paths from './path';
import { SettingsProvider } from './components/layout/Settingscontext';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <SettingsProvider>
      <Paths />
    </SettingsProvider>
  </React.StrictMode>
);


